import axios from "axios";

const BASE_HATTRICK_URL = import.meta.env.VITE_HATTRICK_URL;

export const createTestUser = async (meta, user) => {
  return axios.post(BASE_HATTRICK_URL + "testing/account", meta, {
    headers: { Authorization: "Bearer" + user.stsTokenManager.accessToken },
  });
};
